import React from 'react';
import { Switch } from 'react-router';
import PrivateRoute from '../../components/PrivateRoute.tsx';
import DispensaDisciplinaListPage from './DispensaDisciplinaListPage.js';
import DisciplineFormPage from './DispensaDisciplinaFormPage.js';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/dispensas/disciplinas"
      permission="curricula.view_informeddiscipline"
      component={DispensaDisciplinaListPage}
    />
    <PrivateRoute
      exact
      path="/dispensas/disciplinas/:id/edit"
      permission="curricula.change_informeddiscipline"
      component={DisciplineFormPage}
    />
  </Switch>
);
